import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PsRevisionRicsModel } from '../models/ps-revision-rics-model';

@Injectable({
  providedIn: 'root'
})
export class PsRevisionRicsService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  get(idPs: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_RevisionRICS/${idPs}`);
  }

  post(item: PsRevisionRicsModel) {
    return this._http.post<PsRevisionRicsModel>(`${ this.myAppUrl }api/PS_RevisionRICS`, item);
  }

  gettipoInspeccionList() {
    return this._http.get(`${ this.myAppUrl }api/PS_RevisionRICS/TipoInspeccionAlcance`);
  }

  getFinalidadList() {
    return this._http.get(`${ this.myAppUrl }api/PS_RevisionRICS/Finalidad`);
  }

}
